<template>
  <div class="sc-hero">
    <div class="container sc-hero-inner">
      <div class="sc-hero-content">
        <h1 class="sc-hero-title">Staň sa s nami jednotkou</h1>
        <p class="sc-hero-lead">Vo financiách to robíme inak. Staň sa partnerom banky aj poisťovne a vyrastieš spolu s nami.</p>
        <UButton
          size="large"
          glow
          caret
          @click="$emit('cv-open')"
        >
          Chcem byť partnerom
        </UButton>
      </div>
      <div class="sc-hero-visual">
        <img class="sc-hero-image" src="@/assets/sc/formula-w1.png" alt="Staňte sa s nami jedničkou">
      </div>
    </div>
  </div>

</template>

<script>
import UButton from '@/components/UButton.vue';

export default {
  components: {
    UButton,
  },
};
</script>

<style lang="scss" scoped>
.sc-hero {
  padding: 50px 0;
  background-image: url('../assets/sc/pattern-hero.svg');
  background-size: 200% auto;
  background-repeat: no-repeat;
  background-position: center;
  @media screen and (min-width: $screen-md) {
    padding: 100px 0;
    background-size: 1600px 790px;

  }
  .sc-hero-inner {
    @media screen and (min-width: $screen-md) {
      display: flex;
      align-items: center;
    }
  }
  .sc-hero-content {
    flex: 0 0 480px;
  }
  .sc-hero-title {
    font-size: 32px;
    margin-bottom: 40px;
    @media screen and (min-width: $screen-md) {
      font-size: 56px;
    }
  }
  .sc-hero-lead {
    font-size: 20px;
    margin-bottom: 20px;
    @media screen and (min-width: $screen-md) {
      margin-bottom: 100px;
    }
  }
  .sc-hero-visual {
    transform: scale(1.2);
    flex: 1;
    @media screen and (min-width: $screen-md) {
      transform: translateX(50px) scale(1.2);
    }
    @media screen and (min-width: 1600px) {
      transform: translateX(150px) scale(1.6);
    }

  }
  .sc-hero-image {
    display: block;
    width: 100%;
    height: auto;
  }
}
</style>
